import { useIntl } from 'react-intl';

import { Study } from '@/shared/api/protocol-ts/model/dto_study_pb';
import { type TimelinePreview } from '@/shared/ui';

import { useRawMeshViewerCard } from './useRawMeshViewerCard';
import { useRawMeshViewerCardActions } from './useRawMeshViewerCardActions';

export const useRawMeshViewerTimelineItem = (study: Study) => {
  const { formatDate } = useIntl();
  const { title, uploadDate, previewSrc, handleCardClick } =
    useRawMeshViewerCard(study);
  const { isRemoving, CanDelete, openRemoveConfirmModal, openInfoModal } =
    useRawMeshViewerCardActions(study);

  const preview: TimelinePreview | undefined = previewSrc
    ? { src: previewSrc, alt: title, light: true, contain: true }
    : undefined;

  return {
    title,
    time: uploadDate
      ? formatDate(uploadDate, { timeStyle: 'short' })
      : undefined,
    meta: uploadDate
      ? formatDate(uploadDate, { dateStyle: 'medium' })
      : undefined,
    preview,
    isRemoving,
    actionsProps: {
      canDelete: CanDelete,
      onShowInfo: openInfoModal,
      onRemove: openRemoveConfirmModal,
    },
    handleClick: isRemoving ? undefined : handleCardClick,
  };
};
